<div *ngIf="loading" style="text-align: center; padding: 50px">
  <div
    class="spinner-border mr-50"
    style="width: 3rem; height: 3rem"
    role="status"
  >
    <span class="sr-only">Loading...</span>
  </div>
</div>
<div
  *ngIf="
    !loading &&
    this.info.status != 'done' &&
    this.info.status != 'expired' &&
    this.info.status != 'refused' &&
    this.info.status != 'cancelled' &&
    this.info.status != 'sent2payment'
  "
>
  <div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <div class="m-3" style="text-align: -webkit-center" *ngIf="!iframe">
        <!-- Logo -->
        <a
          href="{{ this.info.location.locationWebsite }}"
          target="_blank"
          class="brand-logo"
        >
          <div style="padding-bottom: 10px">
            <img
              src="{{ this.info.location.locationLogo || 'assets/images/profile/user-uploads/location-00.png' }}"
              alt="brand-logo"
              height="120"
            />
          </div>
          <h2 class="brand-text ml-1">{{ this.info.location.locationName }}</h2>
          <h6>Choose a care plan that best fits your needs:</h6>
        </a>
        <!-- /Logo -->
      </div>
      <div class="bs-stepper checkout-tab-steps m-2" id="checkoutStepper">
        <!-- Wizard starts -->
        <div class="bs-stepper-header" [hidden]="iframe">
          <div class="step" data-target="#step-start">
            <button type="button" class="step-trigger">
              <span class="bs-stepper-box">
                <i data-feather="plus-square" class="font-medium-3"></i>
              </span>
              <span class="bs-stepper-label">
                <span class="bs-stepper-title">Start</span>
                <span class="bs-stepper-subtitle">Select Plan</span>
              </span>
            </button>
          </div>
          <div class="line">
            <i data-feather="chevron-right" class="font-medium-2"></i>
          </div>
          <div class="step" data-target="#step-form">
            <button
              type="button"
              [disabled]="totalPrice[paymentPer] === 0"
              class="step-trigger"
            >
              <span class="bs-stepper-box">
                <i data-feather="clipboard" class="font-medium-3"></i>
              </span>
              <span class="bs-stepper-label">
                <span class="bs-stepper-title">Form</span>
                <span class="bs-stepper-subtitle">Personal Details</span>
              </span>
            </button>
          </div>
          <div class="line">
            <i data-feather="chevron-right" class="font-medium-2"></i>
          </div>
          <div class="step" data-target="#step-dependents">
            <button
              type="button"
              [disabled]="!this.dataForm[0].isInCart"
              class="step-trigger"
            >
              <span class="bs-stepper-box">
                <i data-feather="users" class="font-medium-3"></i>
              </span>
              <span class="bs-stepper-label">
                <span class="bs-stepper-title">Dependents</span>
                <span class="bs-stepper-subtitle">Add Dependents</span>
              </span>
            </button>
          </div>
          <div class="line">
            <i data-feather="chevron-right" class="font-medium-2"></i>
          </div>
          <div class="step" data-target="#step-review">
            <button
              type="button"
              [disabled]="!isCartDone()"
              class="step-trigger"
            >
              <span class="bs-stepper-box">
                <i data-feather="eye" class="font-medium-3"></i>
              </span>
              <span class="bs-stepper-label">
                <span class="bs-stepper-title">Review</span>
                <span class="bs-stepper-subtitle">Review info</span>
              </span>
            </button>
          </div>
        </div>
        <!-- Wizard ends -->

        <div class="row" style="margin-top: 2rem">
          <div class="col-md-8 col-sm-12">
            <div class="bs-stepper-content" style="padding: 0px">
              <!-- Checkout Place order starts -->
              <div id="step-start" class="bs-stepper-content content">
                <div id="place-order" class="product-checkout">
                  <!-- Checkout Place Order Left starts -->
                  <div class="flex-column row col-6 align-items-start mb-2">
                    <h5>Start at:</h5>
                    <input
                      type="date"
                      class="form-control"
                      aria-describedby="basic-icon-default-name2"
                      id="starAtDate"
                      name="starAtDate"
                      min="{{ today | date : 'dd-MM-yyyy'}}"
                      value="{{ today }}"
                      [(ngModel)]="startAtDate"
                      (change)="logDate()"
                      required
                    />
                  </div>
                  <div class="checkout-items">
                    <h5>Select Account Holder Plan:</h5>
                    <!-- Start Item Checkout -->
                    <ng-container *ngFor="let product of products">
                      <div class="card">
                        <div class="row" style="padding: 20px">
                          <div class="col-md-8 col-sm-12">
                            <div style="padding-bottom: 15px">
                              <h4 class="mb-0">
                                {{ product.title }}
                              </h4>
                            </div>
                            <div style="height: 50px; overflow-y: auto;">
                              <p style="font-size: 12px">
                                {{ product.description }}
                              </p>
                            </div>
                            <hr />
                            <div id="treatment">
                              <div *ngFor="let treatment of product.treatment">
                                <i data-feather="check" class="text-primary font-medium-5 font-b" ></i>
                                <span *ngIf="treatment.annualQuantity > 0;else unlimited">{{ treatment.annualQuantity }} {{treatment.title }}</span>
                                <ng-template #unlimited>
                                  {{ treatment.title }}
                                </ng-template>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-md-4 col-sm-12"
                            style="
                              align-self: center;
                              text-align: -webkit-center;
                            "
                          >
                            <sup class="font-medium-1 font-weight-bold">$ </sup>
                            <span
                              class="pricing-standard-value font-weight-bolder"
                              style="font-size: 28px"
                              >{{
                                paymentPer == "weekly"
                                  ? product.pricing.weekly.toFixed(2)
                                  : paymentPer == "fortnightly"
                                  ? product.pricing.fortnightly.toFixed(2)
                                  : paymentPer == "monthly"
                                  ? product.pricing.monthly.toFixed(2)
                                  : product.pricing.annually.toFixed(2)
                              }}</span
                            >

                            <select
                              class="form-control w-50"
                              id="routeSelect"
                              [(ngModel)]="paymentPer"
                              style="font-size: 12px; height: 30px"
                            >
                              <option
                                *ngFor="
                                  let item of product.pricing
                                    | keyvalue
                                    | filterValue
                                "
                                value="{{ item.key }}"
                              >
                                / {{ item.key }}
                              </option>
                            </select>

                            <button
                              type="button"
                              class="btn btn-block btn-next place-order"
                              [ngClass]="
                                product.isInCart === true
                                  ? 'btn-primary'
                                  : 'btn-outline-primary'
                              "
                              style="margin-top: 30px"
                              (click)="selectProduct(product.id)"
                              rippleEffect
                            >
                              <i
                                class="align-middle fa mr-25"
                                [ngClass]="
                                  product.isInCart === true
                                    ? 'fa-check text-white'
                                    : ''
                                "
                              ></i>
                              {{
                                product.isInCart === true
                                  ? "Selected"
                                  : "Select"
                              }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <!-- End Item Checkout -->
                  </div>
                  <!-- Checkout Place Order Left ends -->
                </div>
                <!-- Checkout Place order Ends -->
              </div>
              <!-- Checkout Account Holder Starts -->
              <div id="step-form" class="content">
                <form
                  id="checkout-address"
                  class="product-checkout"
                  [formGroup]="registerForm"
                  (ngSubmit)="onSubmit()"
                  #addressForm="ngForm"
                >
                  <!-- Checkout Account Holder Left starts -->
                  <div class="card">
                    <div class="card-header flex-column align-items-start">
                      <h4 class="card-title">
                        Account Holder Personal Details
                      </h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group col-6">
                          <label for="register-firstName" class="form-label"
                            >First Name</label
                          >
                          <input
                            type="text"
                            formControlName="firstName"
                            class="form-control"
                            placeholder="John"
                            aria-describedby="register-firstName"
                            tabindex="1"
                            name="firstName0"
                            id="firstName0"
                            [ngClass]="{
                              'is-invalid': submitted && f.firstName.errors
                            }"
                          />
                          <div
                            *ngIf="submitted && f.firstName.errors"
                            class="invalid-feedback"
                          >
                            <div *ngIf="f.firstName.errors.required">
                              First Name is required
                            </div>
                          </div>
                        </div>
                        <div class="form-group col-6">
                          <label for="register-lastName" class="form-label"
                            >Last Name</label
                          >
                          <input
                            type="text"
                            formControlName="lastName"
                            class="form-control"
                            placeholder="Doe"
                            aria-describedby="register-lastName"
                            tabindex="2"
                            name="lastName"
                            id="lastName0"
                            [ngClass]="{
                              'is-invalid': submitted && f.lastName.errors
                            }"
                          />
                          <div
                            *ngIf="submitted && f.lastName.errors"
                            class="invalid-feedback"
                          >
                            <div *ngIf="f.lastName.errors.required">
                              Last Name is required
                            </div>
                          </div>
                        </div>
                        <div class="form-group col-6">
                          <label class="form-label" for="basic-icon-default-DoB"
                            >Date of Birth</label
                          >
                          <div class="input-group">
                            <input
                              type="date"
                              class="form-control"
                              formControlName="DoB"
                              aria-describedby="basic-icon-default-name2"
                              tabindex="3"
                              name="DoB0"
                              id="DoB0"
                              [value]="dataForm[0].DoB"
                              [(ngModel)]="dataForm[0].DoB"
                              [ngClass]="{
                                'is-invalid': submitted && f.DoB.errors
                              }"
                            />
                          </div>
                          <div
                            *ngIf="submitted && f.DoB.errors"
                            class="invalid-feedback"
                          >
                            <div *ngIf="f.DoB.errors.required">
                              Date of Birth is required
                            </div>
                          </div>
                        </div>
                        <div class="form-group col-6">
                          <label
                            class="form-label"
                            for="basic-icon-default-gender"
                            >Gender</label
                          >
                          <select
                            class="form-control"
                            formControlName="gender"
                            tabindex="4"
                            name="gender"
                            id="gender0"
                            [ngClass]="{
                              'is-invalid': submitted && f.gender.errors
                            }"
                          >
                            <option value=""></option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                          </select>
                          <div
                            *ngIf="submitted && f.gender.errors"
                            class="invalid-feedback"
                          >
                            <div *ngIf="f.gender.errors.required">
                              Gender is required
                            </div>
                          </div>
                        </div>
                        <div class="form-group col-12">
                          <!-- GOOGLE MAPS -->
                          <label for="register-address" class="form-label"
                            >Address</label
                          >
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <button
                                class="btn"
                                id="btnMaps"
                                [ngClass]="
                                  dataForm[0].postal_code === ''
                                    ? 'btn-outline-danger'
                                    : 'btn-primary'
                                "
                                type="button"
                                rippleEffect
                              >
                                <i data-feather="map-pin"></i>
                              </button>
                            </div>
                            <input
                              type="text"
                              #addresstext
                              id="addresstext0"
                              formControlName="address"
                              class="form-control"
                              placeholder="15 Jonh St, Southport, Gold Coast, QLD, Australia"
                              aria-describedby="register-address"
                              tabindex="5"
                              [ngClass]="{
                                'is-invalid': submitted && f.address.errors
                              }"
                            />
                            <div class="input-group-append">
                              <button
                                class="btn btn-outline-primary"
                                type="button"
                                rippleEffect
                              >
                                <i data-feather="search"></i>
                              </button>
                            </div>
                          </div>
                          <button
                            class="btn btn-outline-primary"
                            (click)="validInfo('address')"
                            type="button"
                            id="validAddress"
                            style="display: none"
                            rippleEffect
                          >
                            <i data-feather="search"></i>
                          </button>

                          <!-- / GOOGLE MAPS -->

                          <div
                            *ngIf="submitted && f.address.errors"
                            class="invalid-feedback"
                          >
                            <div *ngIf="f.address.errors.required">
                              Address is required
                            </div>
                          </div>
                        </div>
                        <div class="form-group col-6">
                          <label for="register-email" class="form-label"
                            >Email</label
                          >
                          <input
                            type="text"
                            formControlName="email"
                            id="email0"
                            class="form-control"
                            placeholder="john@example.com"
                            aria-describedby="register-email"
                            tabindex="6"
                            name="email"
                            [ngClass]="{
                              'is-invalid': submitted && f.email.errors
                            }"
                          />
                          <div
                            *ngIf="submitted && f.email.errors"
                            class="invalid-feedback"
                          >
                            <div *ngIf="f.email.errors.required">
                              Email is required
                            </div>
                            <div *ngIf="f.email.errors.email">
                              Email must be a valid email address
                            </div>
                          </div>
                          <button
                            class="btn btn-outline-primary"
                            (click)="validInfo('email')"
                            type="button"
                            id="validEmail"
                            style="display: none"
                            rippleEffect
                          >
                            <i data-feather="search"></i>
                          </button>
                        </div>
                        <div class="form-group col-6">
                          <label
                            class="form-label"
                            for="basic-icon-default-phone"
                            >Phone</label
                          >
                          <input
                            type="text"
                            id="phoneNumber0"
                            class="form-control"
                            tabindex="7"
                            mask="9000 000 000"
                            placeholder="0000 000 000"
                            aria-describedby="basic-addon"
                            formControlName="phoneNumber"
                            name="phoneNumber"
                            [ngClass]="{
                              'is-invalid': submitted && f.phoneNumber.errors
                            }"
                          />
                          <div
                            *ngIf="submitted && f.phoneNumber.errors"
                            class="invalid-feedback"
                          >
                            <div *ngIf="f.phoneNumber.errors.required">
                              Phone is required
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div style="text-align: center;">
                        <button class="btn btn-success btn-submit" [disabled]="registerForm.status === 'INVALID'" rippleEffect>Check Account Holder</button>
                      </div> -->
                      <div>
                        <button
                          type="button"
                          id="previousStepBtn"
                          class="btn btn-secondary float-left place-order"
                          style="width: 105px"
                          (click)="previousStep()"
                          tabindex="9"
                          rippleEffect
                        >
                          Previous
                        </button>
                        <button
                          type="button"
                          id="nextStepBtn"
                          class="btn btn-primary float-right place-order"
                          style="width: 105px"
                          (click)="onSubmit()"
                          
                          tabindex="8"
                          rippleEffect
                        >
                          Next
                        </button>

                        <button
                          type="button"
                          id="nextStep"
                          class="btn btn-primary float-right place-order"
                          style="width: 105px; display: none"
                          (click)="nextStep()"
                          rippleEffect
                        >
                          nextStep
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Checkout Account Holder Left ends -->
                </form>
              </div>
              <!-- Checkout Account Holder Ends -->

              <!-- Checkout Customer Dependents Starts -->
              <div id="step-dependents" class="content m-3">
                <button
                  style="width: 100%; margin-bottom: 20px"
                  class="btn btn-outline-primary btn-next delivery-address"
                  (click)="addDependent()"
                  rippleEffect
                >
                  <b>ADD DEPENDENT</b><br />
                  <small>
                    10% off per dependent for the account holder, and <br />
                    10% off for the added dependent
                  </small>
                </button>

                <button
                  style="width: 100%; margin-bottom: 20px"
                  class="btn btn-primary delivery-address"
                  (click)=" nextStep()"
                  [disabled]="!isCartDone()"
                  rippleEffect
                >
                  <b>PROCEED TO PAYMENT</b>
                </button>
                <form
                  #dependentForm="ngForm"
                  action="#"
                  class="invoice-repeater"
                >
                  <div *ngFor="let item of this.dataForm; let i = index">
                    <div class="card" *ngIf="i > 0">
                      <div class="row" style="padding: 20px">
                        <div class="col-12 row" style="padding-bottom: 20px">
                          <div class="col-md-4 col-12">
                            <h5>Dependent {{ i }}:</h5>
                          </div>
                          <div class="col-md-4 col-6">
                            <select
                              class="form-control"
                              [(ngModel)]="dataForm[i].plan_id"
                              name="plan{{ i }}"
                              id="plan{{ i }}"
                              (change)="setPrice(i, dataForm[i].plan_id)"
                              [disabled]="dataForm[i].isInCart == true"
                            >
                              <option value="" selected hidden>
                                Select a Plan
                              </option>
                              <option
                                *ngFor="let plan of products"
                                selected="this.dataForm[0].plan_id === plan.id"
                                [value]="plan.id"
                              >
                                {{ plan.title }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-4 col-6">
                            <div
                              class="detail-amt font-weight-bolder"
                              *ngIf="dataForm[i].planPrices != undefined"
                            >
                              <sup class="font-medium-1 font-weight-bold"
                                >$
                              </sup>
                              <span
                                class="pricing-standard-value font-weight-bolder"
                                style="font-size: 28px"
                              >
                                {{
                                  dataForm[i].planPrices[paymentPer].toFixed(2)
                                }} </span
                              ><small>/{{ paymentPer[0] }}</small>
                            </div>
                            <div
                              class="badge badge-glow badge-success"
                              style="
                                font-size: 12px;
                                position: absolute;
                                right: 0px;
                                top: -10px;
                              "
                            >
                              -10%
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="item.firstName"
                              name="firstName{{ i }}"
                              id="firstName{{ i }}"
                              placeholder="First Name"
                              [disabled]="dataForm[i].isInCart == true"
                            />
                          </div>
                        </div>

                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="dataForm[i].lastName"
                              name="lastName{{ i }}"
                              id="lastName{{ i }}"
                              placeholder="Last Name"
                              [disabled]="dataForm[i].isInCart == true"
                            />
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <div class="input-group">
                              <input
                                type="date"
                                class="form-control"
                                aria-describedby="basic-icon-default-name2"
                                name="DoB{{ i }}"
                                id="DoB{{ i }}"
                                [value]="today"
                                [(ngModel)]="dataForm[i].DoB"
                                [disabled]="dataForm[i].isInCart == true"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <select
                              class="form-control"
                              [(ngModel)]="dataForm[i].gender"
                              name="gender{{ i }}"
                              id="gender{{ i }}"
                              placeholder="yyyy-mm-dd"
                              [disabled]="dataForm[i].isInCart == true"
                            >
                              <option value="" selected hidden>
                                Select Gender
                              </option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Other">Other</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-md-6 col-12">
                          <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="dataForm[i].email"
                            name="email{{ i }}"
                            id="email{{ i }}"
                            placeholder="Email"
                            [disabled]="dataForm[i].isInCart == true"
                          />
                        </div>
                        <div class="col-md-6 col-12">
                          <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="dataForm[i].phoneNumber"
                            name="phoneNumber{{ i }}"
                            id="phoneNumber{{ i }}"
                            placeholder="0000 000 000"
                            mask="9000 000 000"
                            placeholder="Phone"
                            [disabled]="dataForm[i].isInCart == true"
                          />
                        </div>
                        <div style="padding: 20px">
                          <button
                            type="submit"
                            class="btn btn-secondary btn-prev delivery-address"
                            (click)="deleteItem(i)"
                            [disabled]="dataForm[i].isInCart == true"
                            rippleEffect
                          >
                            Remove
                          </button>
                          <button
                            type="submit"
                            style="right: 20px; position: absolute"
                            class="btn btn-primary btn-next delivery-address"
                            (click)="selectDependentProduct(i)"
                            rippleEffect
                          >
                            ADD
                          </button>
                          <button
                            type="submit"
                            *ngIf="dataForm[i].isInCart == true"
                            style="right: 20px; position: absolute"
                            class="btn btn-success btn-next delivery-address"
                            (click)="unselectDependentProduct(i)"
                            rippleEffect
                          >
                            ADDED
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- Checkout Customer Dependents Ends -->

              <!-- Checkout Payment Starts -->
              <div id="step-review" class="content">
                <form
                  id="checkout-payment"
                  class="product-checkout"
                  onsubmit="return false;"
                >
                  <div class="card">
                    <div class="card-header flex-column align-items-start">
                      <p class="card-text text-muted mt-25">ACCOUNT HOLDER</p>
                    </div>
                    <div class="card-body" *ngIf="dataForm[0].plan_id > 0">
                      <h6>
                        <b>{{ currentPlanTitle(dataForm[0].plan_id).title }}</b>
                      </h6>
                      <hr class="my-2" />
                      <div class="ml-5 row">
                        <div class="col-6">
                          <p><b>First Name:</b> {{ dataForm[0].firstName }}</p>
                          <p>
                            <b>Date of Birth:</b>
                            {{ dataForm[0].DoB | date : 'dd-MM-yyyy' }}
                          </p>
                          <p><b>E-mail:</b> {{ dataForm[0].email }}</p>
                        </div>
                        <div class="col-6">
                          <p><b>Last Name:</b> {{ dataForm[0].lastName }}</p>
                          <p><b>Gender:</b> {{ dataForm[0].gender }}</p>
                          <p><b>Contact:</b> {{ dataForm[0].phoneNumber }}</p>
                        </div>
                        <div class="col-12">
                          <p><b>Address:</b> {{ dataForm[0].address }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="card-header flex-column align-items-start">
                      <p class="card-text text-muted mt-25">DEPENDENTS</p>
                    </div>
                    <div
                      class="card-body"
                      *ngFor="
                        let item of dataForm | slice : 1 : 20;
                        let i = index
                      "
                    >
                      <h6>
                        <b>{{ currentPlanTitle(item.plan_id).title }}</b>
                      </h6>
                      <hr class="my-2" />
                      <div class="ml-5 row">
                        <div class="col-6">
                          <p><b>First Name:</b> {{ item.firstName }}</p>
                          <p><b>Date of Birth:</b> {{ item.DoB | date : 'dd-MM-yyyy' }}</p>
                          <p><b>E-mail:</b> {{ item.email }}</p>
                        </div>
                        <div class="col-6">
                          <p><b>Last Name:</b> {{ item.lastName }}</p>
                          <p><b>Gender:</b> {{ item.gender }}</p>
                          <p><b>Contact:</b> {{ item.phoneNumber }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="form-group">
                        <div class="custom-control custom-checkbox">
                          <input class="custom-control-input" type="checkbox" formControlName="checkbox" [checked]="termCheck" (click)="checkTermInput()" id="register-privacy-policy" tabindex="10" />
                          <label class="custom-control-label" for="register-privacy-policy">
                            I agree to <a href="javascript:void(0);" (click)="modalOpen(modalPdfView, 'xl')">privacy policy & terms</a>
                          </label>
                        </div>
                      </div>
                      <button
                        type="button"
                        id="previousStepBtn"
                        class="btn btn-secondary float-left place-order"
                        style="width: 150px"
                        [disabled]="loadingButton"
                        (click)="previousStep()"
                        rippleEffect
                      >
                        Previous
                      </button>
                      <button
                          type="button"
                          id="btnToSendForm"
                          class="btn btn-primary float-right place-order"
                          style="width: 105px; display: none"
                          (click)="btnToSendForm()"
                          rippleEffect
                        >
                        SubmitStep
                      </button>
                      <button
                        style="width: 150px"
                        id="sendStepBtn"
                        class="btn btn-primary float-right place-order"
                        [disabled]="!termCheck || loadingButton"
                        (click)="sendForm()"
                        rippleEffect

                      >
                        <b>
                          <span *ngIf="loadingButton" class="spinner-border spinner-border-sm mr-1"></span>
                          Submit
                        </b>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <!-- Checkout Payment Ends -->
            </div>
          </div>

          <div class="col-md-4 col-sm-12">
            <!-- Checkout Place Order Right starts -->
            <div class="checkout-options">
              <div class="card">
                <div class="card-body">
                  <div class="input-group input-group-merge">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Coupon"
                      aria-label="Coupon"
                      id="couponCode"
                      aria-describedby="input-coupons"
                      style='text-transform:uppercase'
                      [disabled]="loadingButton"

                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-primary"
                        type="button"
                        rippleEffect
                        [disabled]="loadingButton"
                        (click)="checkCoupon()"
                      >
                        <span *ngIf="loadingButton" class="spinner-border spinner-border-sm mr-1"></span>
                        Apply
                      </button>
                    </div>
                  </div>
                  <hr />

                  <div class="price-details">
                    <h3>Join Fee 
                      <small style="float: right;font-size: 1.2rem;"><b> ${{(priceCounter.setupFee.total).toFixed(2)}}</b> </small>
                      <small style="font-size: 0.8rem;">(just once) </small>
                    
                    </h3>
                    <br>
                    <h3 class="section-label">Account Holder 
                      <small style="float: right;font-size: 1rem;">${{(priceCounter.setupFee.holder).toFixed(2)}}</small>
                    </h3>
                    <br>
                    <h3 class="section-label mb-1">Dependents
                      <small style="float: right;font-size: 1rem;">${{(priceCounter.setupFee.dependents).toFixed(2)}}
                      </small>
                    </h3>                    
                    <ul class="list-unstyled">
                      <ng-container *ngFor="let discount of discountList;">       
                        <li
                          class="price-detail"
                          *ngIf="discount.valid === true && (priceCounter.setupFee.dependents != 0 || priceCounter.setupFee.holder != 0)"
                        >
                        <div class="detail-amt discount-amt text-success">
                          {{ discount.name }}
                            <small style="float: right;font-size: 1rem;">-${{ (discount.couponSetupDiscount).toFixed(2) }}
                            </small>
                        </div>
                          
                        </li>
                      </ng-container>
                    </ul>
                    <h3 class="section-label mb-1">SmilePass Fee
                      <small style="float: right;font-size: 1rem;">${{(priceCounter.setupFee.smilepass).toFixed(2)}}</small>
                    </h3>
                    <hr />

                    <h3 style="text-transform:capitalize;">{{ this.paymentPer }} Fee 
                      <small style="float: right;font-size: 1.2rem;" ><b>
                        ${{(
                          this.priceCounter.membershipFee.total[paymentPer]  
                          ).toFixed(2)}}
                      </b></small>
                    </h3>
                    <br>

                    <h3 class="section-label">Account Holder 
                      <small style="float: right;font-size: 1rem;" *ngIf="discountList[0].valid === true" >${{(priceCounter.membershipFee.holder[paymentPer] - (discountList[0].membership_amount/dataForm.length) - (priceCounter.membershipFee.holder[paymentPer] * discountList[0].membership_percentage / 100)).toFixed(2)}}</small>
                      <small style="float: right;font-size: 1rem;" *ngIf="discountList[0].valid === false" >${{(priceCounter.membershipFee.holder[paymentPer]).toFixed(2)}}</small>
                    </h3>
                    <ul class="list-unstyled">
                      <ng-container *ngFor="let product of products;">
                        <li
                          class="price-detail"
                          *ngIf="product.isInCart === true"
                        >
                          <div class="detail-title">{{ product.title }}
                            <small style="float: right;font-size: 0,8rem;">
                            ${{ product.pricing[paymentPer].toFixed(2) }}
                            </small>
                          </div>
                        </li>
                      </ng-container>
                    </ul>
                  
                    <h3 class="section-label">Dependents
                      <small style="float: right;font-size: 1rem;" *ngIf="discountList[0].valid === true" >${{ (priceCounter.membershipFee.dependents[paymentPer] - (discountList[0].membership_amount/dataForm.length) - (priceCounter.membershipFee.dependents[paymentPer] * discountList[0].membership_percentage / 100)).toFixed(2) }}</small>
                      <small style="float: right;font-size: 1rem;" *ngIf="discountList[0].valid === false" >${{ (priceCounter.membershipFee.dependents[paymentPer]).toFixed(2) }}</small>
                    </h3>

                    <ul class="list-unstyled">
                      <ng-container *ngFor="let product of products">
                        <li
                          class="price-detail"
                          *ngIf="product.isInDependentCartList === true"
                        >
                          <div class="detail-title">
                            {{ product.qtyInDependentCart }} {{ product.title }}
                            <small style="float: right;font-size: 0,8rem;">
                              ${{
                                (
                                  product.pricing[paymentPer] *
                                  product.qtyInDependentCart
                                ).toFixed(2)
                              }}
                            </small>
                          </div>
                          
                        </li>
                      </ng-container>
                    </ul>
                    <ul class="list-unstyled">
                      <ng-container *ngFor="let discount of discountList;">
                        <li
                          class="price-detail"
                          *ngIf="discount.valid === true && (priceCounter.membershipFee.dependents[paymentPer] != 0 || priceCounter.membershipFee.holder[paymentPer] != 0)"
                        >
                        <div class="detail-amt discount-amt text-success">
                          {{ discount.name }}
                            <small style="float: right;font-size: 1rem;">-${{ discount.couponMembershipDiscount[paymentPer].toFixed(2) }}
                            </small>
                        </div>
                        </li>
                      </ng-container>
                    </ul>
                    <h3 class="section-label mb-1">SmilePass Fee
                      <small style="float: right;font-size: 1rem;">${{(priceCounter.membershipFee.smilepass[paymentPer]).toFixed(2)}}</small>
                    </h3>

                  </div>
                
                </div>
              </div>
            </div>
            <!-- Checkout Place Order Right ends -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Token Status DONE -->
<div *ngIf="!loading && this.info.status == 'done'">
  <div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <div class="m-3" style="text-align: -webkit-center">
        <!-- Logo -->
        <a
          href="{{ this.info.location.locationWebsite }}"
          target="_blank"
          class="brand-logo"
        >
          <div style="padding-bottom: 10px">
            <img
              src="{{ this.info.location.locationLogo }}"
              alt="brand-logo"
              height="40"
            />
          </div>
        </a>
        <!-- /Logo -->
        <h2 class="brand-text ml-1">{{ this.info.location.locationName }}</h2>

        <div style="text-align: center">

          <span>Call Us: <a id="formatted-number" href="tel:+61{{this.info.location.locationPhone}}"> +61 {{formatPhoneNumber(this.info.location.locationPhone)}}</a>
          </span
            ><br />
            <a
              href="{{ this.info.location.locationWebsite }}"
              target="_blank"
            >
              <span>{{ this.info.location.locationWebsite }}</span>
            </a>
        </div>

      </div>
    </div>
  </div>
</div>
<!-- /Token Status DONE -->

<!-- Token Status SENT2PAYMENT -->
<div *ngIf="!loading && this.info.status == 'sent2payment'">
  <div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <div class="m-3" style="text-align: -webkit-center">
        <!-- Logo -->
        <a
          href="{{ this.info.location.locationWebsite }}"
          target="_blank"
          class="brand-logo"
        >
          <div style="padding-bottom: 10px">
            <img
              src="{{ this.info.location.locationLogo }}"
              alt="brand-logo"
              height="40"
            />
          </div>
        </a>
        <!-- /Logo -->

        <h2 class="brand-text ml-1">{{ this.info.location.locationName }}</h2>

        <div><p>You will be redirected to complete the payment. If it doesn't open, click <a href= "${
          data.url }
        ">here</a>!</p></div>

        <div style="text-align: center">

          <span>Call Us: <a id="formatted-number" href="tel:+61{{this.info.location.locationPhone}}"> +61 {{formatPhoneNumber(this.info.location.locationPhone)}}</a>
          </span
            ><br />
            <a
              href="{{ this.info.location.locationWebsite }}"
              target="_blank"
            >
              <span>{{ this.info.location.locationWebsite }}</span>
            </a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /Token Status SENT2PAYMENT -->


<!-- Token Status EXPIRED or REFUSED -->
<div *ngIf="!loading">
  <table
    *ngIf="
      this.info.status == 'expired' ||
      this.info.status == 'refused' ||
      this.info.status == 'cancelled'
    "
    style="font-family: 'Montserrat', Arial, sans-serif; width: 100%"
    width="100%"
    cellpadding="0"
    cellspacing="0"
    role="presentation"
  >
    <tbody>
      <tr>
        <td
          class="sm-px-24"
          style="
            --bg-opacity: 1;
            background-color: #ffffff;
            background-color: rgba(255, 255, 255, var(--bg-opacity));
            border-radius: 4px;
            font-family: Montserrat, -apple-system, 'Segoe UI', sans-serif;
            font-size: 14px;
            line-height: 24px;
            padding: 48px;
            text-align: left;
            --text-opacity: 1;
            color: #626262;
            color: rgba(98, 98, 98, var(--text-opacity));
          "
          bgcolor="rgba(255, 255, 255, var(--bg-opacity))"
          align="left"
        >
          <p style="font-weight: 600; font-size: 18px; margin-bottom: 0">Hey</p>
          <p
            style="
              font-weight: 700;
              font-size: 20px;
              margin-top: 0;
              --text-opacity: 1;
              color: #ff5850;
              color: rgba(255, 88, 80, var(--text-opacity));
            "
          >
            {{ this.info.result.lead.firstName }}
            {{ this.info.result.lead.lastName }}!
          </p>
          <p
            class="sm-leading-32"
            style="
              font-weight: 600;
              font-size: 20px;
              margin: 0 0 16px;
              --text-opacity: 1;
              color: #263238;
              color: rgba(38, 50, 56, var(--text-opacity));
            "
          >
            Your Invite has expired or been declined! 😔
          </p>
          <p>
            This invitation is deactivated due to one of the following reason:
          </p>
          <ul style="margin-bottom: 24px">
            <li>You have refused your invite yourself.</li>
            <li>
              SmilePass staff refused your invite due to policy violation.
            </li>
            <li>
              Your invitation was sent more than 30 days ago and has expired.
            </li>
            <li>Your invitation was paid, but you have cancelled it.</li>
          </ul>
          <p style="margin: 0">
            If you did not intend to refused your invitation or need our help,
            please contact us at
            <a
              href="mailto:contact@smilepass.co"
              class="hover-underline"
              style="
                --text-opacity: 1;
                color: #7367f0;
                color: rgba(115, 103, 240, var(--text-opacity));
                text-decoration: none;
              "
              >contact@smilepass.co</a
            >
          </p>
          <table
            style="font-family: 'Montserrat', Arial, sans-serif; width: 100%"
            width="100%"
            cellpadding="0"
            cellspacing="0"
            role="presentation"
          >
            <tbody>
              <tr>
                <td
                  style="
                    font-family: 'Montserrat', Arial, sans-serif;
                    padding-top: 32px;
                    padding-bottom: 32px;
                  "
                >
                  <div
                    style="
                      --bg-opacity: 1;
                      background-color: #eceff1;
                      background-color: rgba(236, 239, 241, var(--bg-opacity));
                      height: 1px;
                      line-height: 1px;
                    "
                  >
                    &zwnj;
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <p style="margin: 0 0 16px">
            Not sure why you received this invite? Please
            <a
              href="mailto:contact@smilepass.co"
              class="hover-underline"
              style="
                --text-opacity: 1;
                color: #7367f0;
                color: rgba(115, 103, 240, var(--text-opacity));
                text-decoration: none;
              "
              >let us know</a
            >.
          </p>
          <p style="margin: 0 0 16px">Thanks, <br />The SmilePass Team</p>
        </td>
      </tr>
      <tr>
        <td
          style="font-family: 'Montserrat', Arial, sans-serif; height: 20px"
          height="20"
        ></td>
      </tr>
    </tbody>
  </table>
</div>
<!-- /Token Status EXPIRED or REFUSED -->

<!-- Footer -->
<div style="margin: 20px" *ngIf="!loading && !iframe">
  <!-- Logo -->
  <div style="text-align: center">
    <a href="javascript:void(0);" class="brand-logo">
      <img
        src="{{ coreConfig.app.appLogoImage }}"
        alt="brand-logo"
        height="28"
      />
      <h2 class="brand-text text-primary">{{ coreConfig.app.appName }}</h2>
    </a>
  </div>
  <!-- /Logo -->
  <!-- <p align="center" style="cursor: default; margin-bottom: 16px;">
        <a href="https://smilepass.co/" target="_blank" style="--text-opacity: 1; color: #263238; color: rgba(38, 50, 56, var(--text-opacity)); text-decoration: none;"><img src="assets/images/icons/facebook.png" width="32" alt="Facebook" style="border: 0; max-width: 100%; line-height: 100%; vertical-align: middle; margin-right: 12px;"></a>
        
        <a href="https://smilepass.co/" target="_blank" style="--text-opacity: 1; color: #263238; color: rgba(38, 50, 56, var(--text-opacity)); text-decoration: none;"><img src="assets/images/icons/twitter.png" width="32" alt="Twitter" style="border: 0; max-width: 100%; line-height: 100%; vertical-align: middle; margin-right: 12px;"></a>
        
        <a href="https://smilepass.co/" target="_blank" style="--text-opacity: 1; color: #263238; color: rgba(38, 50, 56, var(--text-opacity)); text-decoration: none;"><img src="assets/images/icons/instagram.png" width="32" alt="Instagram" style="border: 0; max-width: 100%; line-height: 100%; vertical-align: middle; margin-right: 12px;"></a>
      </p> -->
  <p
    align="center"
    style="
      --text-opacity: 1;
      color: #263238;
      color: rgba(38, 50, 56, var(--text-opacity));
    "
  >
    Use of our service and website is subject to our
    <a
      href="https://smilepass.co/"
      target="_blank"
      class="hover-underline"
      style="
        --text-opacity: 1;
        color: #7367f0;
        color: rgba(115, 103, 240, var(--text-opacity));
        text-decoration: none;
      "
      >Terms of Use</a
    >
    and
    <a
      href="https://smilepass.co/"
      target="_blank"
      class="hover-underline"
      style="
        --text-opacity: 1;
        color: #7367f0;
        color: rgba(115, 103, 240, var(--text-opacity));
        text-decoration: none;
      "
      >Privacy Policy</a
    >.
  </p>
</div>
<!-- /Footer -->

<!-- Modal Contract Viewer -->
<ng-template #modalPdfView let-modal>
  <div class="modal-header">
    <div>
      <h5 class="modal-title" id="myModalLabel160">Contract Viewer</h5>
    </div>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>

    <div class="row">
      <div class="col-lg-3 col-md-3 col-12">
        <div class="list-group">
          <!-- <button 
            type="button" 
            (click)="selectTerm(i)" 
            *ngFor="let term of data.membership.planTerms; let i = index;" 
            class="list-group-item list-group-item-action"
            [ngClass]="{ 'active': currentTermIdx == i }"
            >{{ term.title }}
          </button> -->
          <button 
          type="button" 
          class="list-group-item list-group-item-action"
          [ngClass]="{ 'active': currentTermIdx == 0 }"
          (click)="selectTerm(0)"
          >{{ this.info.terms_of_use.title }}
        </button>
         <button 
            type="button" 
            (click)="selectTerm(i+1)" 
            *ngFor="let member of dataForm; let i = index;" 
            class="list-group-item list-group-item-action"
            [ngClass]="{ 'active': currentTermIdx == i + 1 }"
            > Member {{ i + 1 }}
          </button>
        </div>  
      </div>
      <div class="col-lg-9 col-md-9 col-12" style="height: 400px; overflow-y: scroll;">
        <div class="form-group">
          <h3>{{this.currentTerm.title}}</h3>
          <div id="term">            
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="confirmTermInput()" rippleEffect>
      Confirm
    </button>
    <button type="button" class="btn btn-secondary" (click)="modal.close('Cancel')" rippleEffect>
      Cancel
    </button>
  </div>
</ng-template>
<!-- / Modal -->